module.exports = __webpack_public_path__ + "Roboto-700.3b38c16e4b39e5fd4017.woff2";


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src634836211/src/src/assets/fonts/roboto/fonts/Roboto-700/Roboto-700.woff2
// module id = ../../../../../src/assets/fonts/roboto/fonts/Roboto-700/Roboto-700.woff2
// module chunks = main styles